import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minutesToHoursMinutes',
    standalone: false
})
export class MinutesToHoursMinutesPipe implements PipeTransform {

  transform(minutes: number | null | undefined): string {
    if (minutes == null || isNaN(minutes as number) || !isFinite(minutes as number)) {
      return '- Hrs   - Min';
    }
    const m = Math.max(0, Math.round(minutes as number));
    return `${Math.floor(m / 60)} Hrs   ${m % 60} Min`;
  }

}
